import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { EventService } from '../../services/event.service';
import { Event } from '../../models/event.model';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-thank-you',
  imports: [CommonModule],
  templateUrl: './thank-you.html',
  styleUrl: './thank-you.css',
})
export class ThankYouComponent implements OnInit, OnDestroy {
  event: Event | null = null;
  loading = false;
  error: string | null = null;

  private destroy$ = new Subject<void>();

  constructor(
    private eventService: EventService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.route.queryParams.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      const token = params['token'];
      
      if (token) {
        this.loading = true;
        this.error = null;
        this.eventService.getEventByToken(token).pipe(
          takeUntil(this.destroy$)
        ).subscribe({
          next: (event) => {
            console.log('Event received:', event);
            
            if (event) {
              this.event = event;
              this.loading = false;
              console.log('Event set, loading:', this.loading, 'event:', this.event);
              
              // Force change detection to ensure template updates
              this.cdr.detectChanges();
            } else {
              this.error = 'Event data is empty. Please try again.';
              this.event = null;
              this.loading = false;
            }
          },
          error: (err) => {
            this.loading = false;
            this.error = 'An error occurred while loading the event.';
            console.error('Error loading event:', err);
          }
        });
      } else {
        this.error = 'No event specified. A registration token is required.';
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  formatEventTime(): string {
    return this.event?.start_time || '';
  }
}
